// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"507":"9e7df8aae3309ec7","651":"581f2143083898e8","4854":"567d5be95c9ad14a","8733":"6af91a9450047a08"}[chunkId] + ".css";
};